/**
 * Shared policy version constant.
 *
 * MUST be bumped whenever any policy document is materially updated.
 * Format: YYYY-MM-DD-vN
 *
 * This version is:
 *   - Written to localStorage on policy acceptance (client-side audit trail).
 *   - Sent to POST /auth/sync-user → written to server-side audit log.
 *   - Stored in admin audit_log.metadata for legal reference.
 *
 * Both client and server must agree on this value — do NOT hardcode it in
 * individual components.
 */
export const CURRENT_POLICY_VERSION = '2026-10-31-v1';
